// ローディング判定
jQuery(window).on("load", function() {
  jQuery("body").attr("data-loading", "true");
});

jQuery(function($) {
  $(window).on("scroll", function() {
    let scrollTop = $(this).scrollTop();
    let windowHeight = $(this).height();
    let documentHeight = $(document).height();

    $("body").attr("data-scroll", scrollTop > 400 ? "true" : "false");
    $("body").attr(
      "data-scroll-bottom",
      documentHeight - (windowHeight + scrollTop) <= 0 ? "true" : "false"
    );
  });

  if (window.matchMedia("(max-width: 750px)").matches) {
    $(".g-nav-item-link._child").on("click", function(e) {
      e.preventDefault();

      let drawer = $(".js-drawer");
      let targetClass = drawer.attr("data-target");
      let ariaControls = drawer.attr("aria-controls");

      $("." + targetClass).toggleClass("is-checked");
      $("body").toggleClass("is-checked");

      $("#" + ariaControls).attr(
        "aria-hidden",
        $("#" + ariaControls).attr("aria-hidden") === "true" ? "false" : "true"
      );

      drawer.attr(
        "aria-expanded",
        drawer.attr("aria-expanded") === "true" ? "false" : "true"
      );

      $(this).toggleClass("active");
      $(this).next(".menu-second").slideToggle();
      $(".g-nav-item-link._child").not(this).removeClass("active");
      $(".g-nav-item-link._child").not(this).next(".menu-second").slideUp();
    });
  }

  $(".js-drawer").on("click", function(e) {
    e.preventDefault();

    let targetClass = $(this).attr("data-target");
    let ariaControls = $(this).attr("aria-controls");

    $("." + targetClass).toggleClass("is-checked");
    $("body").toggleClass("is-checked");

    $("#" + ariaControls).attr(
      "aria-hidden",
      $("#" + ariaControls).attr("aria-hidden") === "true" ? "false" : "true"
    );

    $(this).attr(
      "aria-expanded",
      $(this).attr("aria-expanded") === "true" ? "false" : "true"
    );
  });

  $(".sp-btn").on("click", function() {
    $(this).next().slideToggle();
  });
});
var urlHash = location.hash;
if (urlHash) {
  jQuery("body,html")
    .stop()
    .scrollTop(0);

  setTimeout(function() {
    var target = jQuery(urlHash);
    var position = target.offset().top - 120;
    //ランダムっぽいのでどちらにも対応
    jQuery("body,html")
      .stop()
      .animate({ scrollTop: position }, 300);
  }, 100);
}

jQuery('a[href^="#"]:not(.no_somooth)').click(function() {
  let id = jQuery(this).attr("href");
  let speed = 300;
  let target = jQuery("#" == id ? "html" : id);
  let position = jQuery(target).offset().top - 140;
  if ("fixed" !== jQuery("header").css("position")) {
    position = jQuery(target).offset().top;
  }

  console.log("ok");

  jQuery("html, body").animate(
    {
      scrollTop: position
    },
    speed
  );
  return false;
});

jQuery(function() {
  // aimation呼び出し
  if (jQuery(".js-scroll-trigger").length) {
    scrollAnimation();
  }

  // aimation関数
  function scrollAnimation() {
    jQuery(window).scroll(function() {
      jQuery(".js-scroll-trigger").each(function() {
        let position = jQuery(this).offset().top,
          scroll = jQuery(window).scrollTop(),
          windowHeight = jQuery(window).height();

        if (scroll > position - windowHeight + 200) {
          jQuery(this).addClass("active");
        }
      });
    });
  }
  jQuery(window).trigger("scroll");
});

//wait
jQuery(function() {
  "use waits";

  var dialog = document.getElementById("dialog");
  var waits = document.getElementsByClassName("wait");
  var cancel = document.getElementById("cancel");
  var scrollpos;

  for (let i = 0; i < waits.length; i++) {
    waits[i].addEventListener(
      "click",
      function() {
        dialog.style.visibility = "visible";
        dialog.style.opacity = 1;
        scrollpos = jQuery(window).scrollTop();
        jQuery("body")
          .addClass("fixed")
          .css({ top: -scrollpos });
      },
      false
    );
  }

});

//headerスクロール fix
jQuery(window).on("scroll", function() {
  jQuery("header").css("left", -jQuery(window).scrollLeft());
});

if (window.matchMedia("(min-width: 769px)").matches) {
  /* ウィンドウサイズが 768px以上の場合に有効にしたい処理*/
}
var _window = jQuery(window),
  _header = jQuery("header"),
  heroBottom;

_window.on("scroll", function() {
  /*         heroBottom1 = jQuery(".mv").height();
  heroBottom2 = jQuery(".header-logo").height();
  heroBottom = heroBottom1 - heroBottom2; */
  if (_window.scrollTop() > 20) {
    _header.addClass("transform");
  } else {
    _header.removeClass("transform");
  }
});
_window.trigger("scroll");

var urlHash = location.hash;
if (urlHash) {
  jQuery("body,html")
    .stop()
    .scrollTop(0);

  setTimeout(function() {
    var target = jQuery(urlHash);
    var position = target.offset().top - 120;
    //ランダムっぽいのでどちらにも対応
    jQuery("body,html")
      .stop()
      .animate({ scrollTop: position }, 300);
    console.log(header);
    console.log(position);
  }, 100);
}

//アコーディオン
jQuery(function() {
  jQuery(".qa-item-ttl").each(function() {
    jQuery(this).on("click", function() {
      jQuery(this).toggleClass("on");
      jQuery(this)
        .next(".qa-item-content")
        .slideToggle();
      return false;
    });
  });
});

//overflow ページ内リンク
var scrollAnim = function() {
  var target, targetP, scrollP, position;
  jQuery(".js-over").on("click", function(e) {
    e.preventDefault();

    target = jQuery(this).attr("href");
    targetP = jQuery(target).position();
    scrollH = jQuery(".js-scroll").scrollTop();
    position = targetP.top + scrollH;

    jQuery(".js-scroll").animate(
      {
        scrollTop: position
      },
      400
    );
  });
};
scrollAnim();

jQuery(function() {
  jQuery(".js-acc").click(function() {
    var position = jQuery(this).offset().top;
    jQuery("html,body").animate(
      {
        scrollTop: position - 60 //スクロール位置調整
      },
      {
        queue: false
      }
    );
    jQuery(this)
      .next(".js-acc-content")
      .slideToggle();
    jQuery(this).toggleClass("on");
  });
});






jQuery(function() {

  jQuery(".js-acc-link").on("click", function(e){
    e.preventDefault();

    var targetId = jQuery(this).attr("href");
    var $wrap = jQuery(targetId);
    var $acc = $wrap.find(".js-acc");
    var $content = $acc.next(".js-acc-content");

    var top = $acc.offset().top - 80;

    // 他を閉じる
    //jQuery(".js-acc").not($acc).removeClass("on");
    //jQuery(".js-acc-content").not($content).slideUp(200);

    // スクロール
    jQuery("html,body").stop().animate({
      scrollTop: top
    }, 300, function(){

      // 開く
      $content.slideDown(300);
      $acc.addClass("on");

    });

  });

});
